import React, {useState, useRef, useEffect} from "react";
import {Button} from 'primereact/button';
import {Toast} from 'primereact/toast';
import {InputText} from "primereact/inputtext";
import * as management from "../../actions/management";
import * as auth from "../../actions/auth";
import connect from "react-redux/lib/connect/connect";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import axios from "axios";
import {Dialog} from "primereact/dialog";
import AddServer from "./AddServer";
import {SplitButton} from "primereact/splitbutton";
import Spinner from "../../spinner/Spinner";
import {InputTextarea} from "primereact/inputtextarea";
import {confirmDialog} from "primereact/confirmdialog";
import {Tooltip} from "primereact/tooltip";
import {Badge} from "primereact/badge";
import {ColumnGroup} from "primereact/columngroup";
import {Row} from "primereact/row";
import {Carousel} from "primereact/carousel";
import add_new_server_png from "../../assets/flags/cloud/server/add_new_server.png";
import server_informations_png from "../../assets/flags/cloud/server/server_informations.png";
import select_reservation_png from "../../assets/flags/cloud/server/seleect_reservation.png";
import select_image_png from "../../assets/flags/cloud/server/select_image.png";
import enter_keypair_png from "../../assets/flags/cloud/server/enter_keypair_name.png";
import server_summary_png from "../../assets/flags/cloud/server/server_summary.png";
import {Message} from "primereact/message";
import {Tag} from "primereact/tag";


const Server = props => {
    const toast = useRef(null);
    const [serverListRole, setServerListRole] = useState(true);
    const [serverAddRole, setServerAddRole] = useState(false);
    const [serverUpdateRole, setServerUpdateRole] = useState(false);
    const [serverDeleteRole, setServerDeleteRole] = useState(false);
    const [serverName, setServerName] = useState(null);
    const [serverDetail, setServerDetail] = useState(null);
    const [servList, setServList] = useState([]);
    const [globalFilter1, setGlobalFilter1] = useState('');
    const [serverDialog, setServerDialog] = useState(false);
    const [serverDeleteDialog, setServerDeleteDialog] = useState(false);
    const [serverID, setServerID] = useState(null);
    const [loadingState, setLoadingState] = useState(false);
    const [serverUpdateDialog, setServerUpdateDialog] = useState(false);
    const [reservationDialog, setReservationDialog] = useState(false);
    const [credit, setCredit] = useState(null);
    const [reservations, setReservations] = useState([]);
    const [selectedServer, setSelectedServer] = useState([]);
    const [selectedReservation, setSelectedReservation] = useState(null);
    const [infoDialog, setInfoDialog] = useState(false);

    const create_item = (rowData) => {
        const items = [];
        if (serverUpdateRole) {
            items.push({
                label: 'Güncelle',
                // icon: 'pi pi-refresh',
                command: () => {
                    setServerName(rowData.server_name);
                    setServerDetail(rowData.server_description);
                    setServerUpdateDialog(true);
                    setServerID(rowData.server_id);
                }
            });
        }
        if (serverDeleteRole) {
            items.push({
                label: 'Sil',
                // icon: 'pi pi-times',
                command: () => {
                    confirmDeleteServer(rowData.server_id);
                }
            });
        }
        if (serverUpdateRole) {
            items.push({
                label: 'Başlat',
                // icon: 'pi pi-play',
                command: () => {
                    setSelectedServer(rowData.server_id);
                    confirmServerOperations("start", rowData.server_id);
                }
            });
        }

        if (serverUpdateRole) {
            items.push({
                label: 'Durdur',
                // icon: 'pi pi-pause',
                command: () => {
                    confirmServerOperations("stop", rowData.server_id);
                }
            });
        }

        if (rowData.software_type === "jupyter") {
            items.push({
                label: 'Jupyter Kullanıcı Kılavuzu İndir',
                // icon: 'pi pi-pause',
                command: () => {
                    downloadJupyterGuide();
                }
            });
        }

        items.push({
            label: 'Anahtar Dosyası İndir',
            // icon: 'pi pi-pause',
            command: () => {
                downloadKeypair(rowData.server_id);
            }
        });

        return items;
    }

    useEffect(() => {
            getServList();
            getCredit();
            setInterval(() => {
                getServList();
                getCredit();
            }, 10000);
        }, []
    );

    const getCredit = () => {
        const token = localStorage.getItem("token");
        const headers = {"Authorization": "Token " + token}
        // setLoadingState(true);
        axios.get('api/cloud-user-credit/', {"headers": headers, method: "GET"})
            .then(res => {
                // setLoadingState(false);
                const data = res.data;
                if (data.result) {
                    setServerListRole(true);
                    if (data.credit > 0) {
                        setServerAddRole(true);
                        setServerUpdateRole(true);
                        setServerDeleteRole(true);
                    }
                    setCredit(data.credit);
                } else {
                    setCredit(0);
                    // showError("Krediniz Bulunmamaktadır, Kredi Talebi Sayfasına Yönlendiriliyorsunuz...");
                    // showError(data.message);
                }
            })
    }

    const getServList = () => {
        const token = localStorage.getItem("token");
        const headers = {"Authorization": "Token " + token}
        // setLoadingState(true);
        axios.get('api/cloud-server/', {"headers": headers, method: "GET"})
            .then(res => {
                // setLoadingState(false);
                setServList(res.data.server_list);
            })
    }

    const getReservations = () => {
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            setLoadingState(true);
            headers["Authorization"] = `Token ${token}`;
            fetch("/api/usable-reservations/", {headers, method: "GET"})
                .then(res => {
                    if (res.status < 500) {
                        setLoadingState(false);
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        //console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        setLoadingState(false);
                        const data = res.data;
                        if (data.result) {
                            setReservations(data.reservations);
                        } else {
                            showError(data.message);
                        }
                    } else if (res.status === 401) {
                        props.loadUser();
                        setLoadingState(false);
                        throw res.data;

                    } else if (res.status === 403) {
                        setLoadingState(false);
                        throw res.data;

                    }
                })

        }
    }

    const updateServer = () => {
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            if (!serverName || serverName.length < 5) {
                showError("Sunucu Adı En Az 5 Karakterli Olmalıdır!");
                return;
            }
            const data = {
                "server_id": serverID,
                "server_name": serverName,
                "server_description": serverDetail
            }
            const body = JSON.stringify(data);
            headers["Authorization"] = `Token ${token}`;
            setLoadingState(true);
            fetch("/api/cloud-server/", {headers, method: "PUT", body: body})
                .then(res => {
                    if (res.status < 500) {
                        setLoadingState(false);
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        //console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        setLoadingState(false);
                        setServerUpdateDialog(false);
                        const data = res.data;
                        if (data.result) {
                            showSuccess(data.message);
                            getServList();
                        } else {
                            showError(data.message);
                        }
                    } else if (res.status === 401) {
                        props.loadUser();
                        setLoadingState(false);
                        throw res.data;

                    } else if (res.status === 403) {
                        setLoadingState(false);
                        throw res.data;

                    }
                })

        }
    }

    const deleteServer = (server_id) => {
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");

        if (token) {
            if (server_id === null) {
                showError("Server ID Seçilemedi");
                return;
            }
            headers["Authorization"] = `Token ${token}`;
            setLoadingState(true)
            fetch("/api/cloud-server/" + server_id, {headers, method: "DELETE"})
                .then(res => {
                    if (res.status < 500) {
                        setLoadingState(false);
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        //console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        setLoadingState(false)
                        setServerUpdateDialog(false)
                        const data = res.data;
                        if (data.result) {
                            showSuccess(data.message);
                            getServList();
                        } else {
                            showError(data.message);
                        }
                    } else if (res.status === 401) {
                        props.loadUser();
                        setLoadingState(false);
                        throw res.data;

                    } else if (res.status === 403) {
                        setLoadingState(false);
                        throw res.data;

                    }
                })

        }

    }

    const serverOperations = (server_op_url, server_id) => {
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            const data = {
                "server_id": server_id,
            }

            const body = JSON.stringify(data);
            headers["Authorization"] = `Token ${token}`;
            setLoadingState(true);
            fetch("/api/cloud-server/" + server_op_url + "/", {headers, method: "POST", body: body})
                .then(res => {
                    if (res.status < 500) {
                        setLoadingState(false);
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        //console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        setLoadingState(false);
                        const data = res.data;
                        if (data.result) {
                            showSuccess(data.message);
                        } else {
                            showError(data.message);
                            if (server_op_url === "start") {
                                setReservationDialog(true);
                                getReservations();
                            }
                        }
                    } else if (res.status === 401) {
                        props.loadUser();
                        setLoadingState(false);
                        throw res.data;

                    } else if (res.status === 403) {
                        setLoadingState(false);
                        throw res.data;

                    }
                })

        }
    }

    const serverStartWithReservation = () => {
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            if (selectedReservation === null) {
                showError("Rezervasyon Seçiniz!");
                return;
            }

            const data = {
                "server_id": selectedServer,
                "reservation_id": selectedReservation.reservation_id
            }

            const body = JSON.stringify(data);
            headers["Authorization"] = `Token ${token}`;
            setLoadingState(true);
            fetch("/api/cloud-server/start/reservation/", {headers, method: "POST", body: body})
                .then(res => {
                    if (res.status < 500) {
                        setLoadingState(false);
                        return res.json().then(data => {
                            return {status: res.status, data};
                        })
                    } else {
                        //console.log("Server Error!");
                        throw res;
                    }
                })
                .then(res => {
                    if (res.status === 200) {
                        setLoadingState(false);
                        const data = res.data;
                        if (data.result) {
                            reservationDialogOnHide();
                            showSuccess(data.message);
                        } else {
                            showError(data.message);
                        }
                    } else if (res.status === 401) {
                        props.loadUser();
                        setLoadingState(false);
                        throw res.data;

                    } else if (res.status === 403) {
                        setLoadingState(false);
                        throw res.data;

                    }
                })

        }
    }

    const downloadReservationGuide = () => {
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            headers["Authorization"] = `Token ${token}`;
            axios.get("api/reservation/download/", {
                headers,
                responseType: "blob"
            }).then((response) => {
                let blob = new Blob([response.data],),
                    downloadUrl = window.URL.createObjectURL(blob),
                    filename = "",
                    disposition = response.headers["content-disposition"];

                if (disposition && disposition.indexOf("attachment") !== -1) {
                    let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/,
                        matches = filenameRegex.exec(disposition);
                    if (matches != null && matches[1]) {
                        filename = matches[1].replace(/['"]/g, "");
                    }
                }

                let a = document.createElement("a");
                if (typeof a.download === "undefined") {
                    window.location.href = downloadUrl;
                } else {
                    a.href = downloadUrl;
                    a.download = filename;
                    document.body.appendChild(a);
                    a.click();
                }
            }).catch((error) => {
                // ...
            });
        }
    }

    const downloadKeypair = (server_id) => {
        const token = localStorage.getItem("token");
        const headers = {"Authorization": "Token " + token}
        setLoadingState(true);
        axios.get('api/cloud-server/download/' + server_id, {"headers": headers})
            .then(res => {
                let blob = new Blob([res.data],),
                    downloadUrl = window.URL.createObjectURL(blob),
                    filename = "",
                    disposition = res.headers["content-disposition"];

                if (disposition && disposition.indexOf("attachment") !== -1) {
                    let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/,
                        matches = filenameRegex.exec(disposition);

                    if (matches != null && matches[1]) {
                        filename = matches[1].replace(/['"]/g, "");
                    }
                }
                let a = document.createElement("a");
                if (typeof a.download === "undefined") {
                    window.location.href = downloadUrl;
                } else {
                    a.href = downloadUrl;
                    a.download = filename;
                    document.body.appendChild(a);
                    a.click();
                }
                setLoadingState(false);
            })
    }

    const downloadJupyterGuide = () => {
        let headers = {"Content-Type": "application/json"};
        let token = localStorage.getItem("token");
        if (token) {
            headers["Authorization"] = `Token ${token}`;
            axios.get("api/jupyter/download/", {
                headers,
                responseType: "blob"
            }).then((response) => {
                let blob = new Blob([response.data],),
                    downloadUrl = window.URL.createObjectURL(blob),
                    filename = "",
                    disposition = response.headers["content-disposition"];

                if (disposition && disposition.indexOf("attachment") !== -1) {
                    let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/,
                        matches = filenameRegex.exec(disposition);
                    if (matches != null && matches[1]) {
                        filename = matches[1].replace(/['"]/g, "");
                    }
                }

                let a = document.createElement("a");
                if (typeof a.download === "undefined") {
                    window.location.href = downloadUrl;
                } else {
                    a.href = downloadUrl;
                    a.download = filename;
                    document.body.appendChild(a);
                    a.click();
                }
                setLoadingState(false);
            }).catch((error) => {
                // ...
            });
        }
    }

    const confirmDeleteServer = (server_id) => {
        confirmDialog({
            message: 'Silmek istediğinize emin misiniz?',
            icon: 'pi pi-info-circle',
            header: 'Sunucuyu Sil',
            acceptClassName: 'p-button-danger',
            acceptLabel: 'Evet',
            acceptIcon: 'pi pi-check',
            rejectLabel: 'Hayır',
            rejectIcon: 'pi pi-times',
            accept() {
                deleteServer(server_id)
            },
            reject() {

            }
        });
    }

    const confirmServerOperations = (server_op_url, server_id) => {
        if (server_op_url === "start") {
            confirmDialog({
                message: 'Sunucuyu Başlatmak istediğinize emin misiniz?',
                icon: 'pi pi-info-circle',
                header: 'Sunucuyu Başlat',
                acceptLabel: 'Evet',
                acceptIcon: 'pi pi-check',
                rejectLabel: 'Hayır',
                rejectIcon: 'pi pi-times',
                accept() {
                    serverOperations(server_op_url, server_id)
                },
                reject() {

                }
            });
        } else {
            confirmDialog({
                message: 'Sunucuyu Durdurmak istediğinize emin misiniz?',
                icon: 'pi pi-info-circle',
                header: 'Sunucuyu Durdur',
                acceptClassName: 'p-button-danger',
                acceptLabel: 'Evet',
                acceptIcon: 'pi pi-check',
                rejectLabel: 'Hayır',
                rejectIcon: 'pi pi-times',
                accept() {
                    serverOperations(server_op_url, server_id)
                },
                reject() {

                }
            });
        }

    }

    const showSuccess = (message) => {
        toast.current.show({severity: 'success', summary: message, life: 3000});
    }

    const showError = (message) => {
        toast.current.show({
            severity: 'error',
            summary: message,
            life: 3000
        });
    }

    const showInfo = (message, detail) => {
        toast.current.show({severity: 'info', summary: message, detail: detail, life: 5000});
    }

    const customer1TableHeader = (
        <div className="table-header">
            <div className="p-grid">
                <div className="p-col-12 p-sm-12 p-md-6 p-lg-6 p-xl-6" align="left">
                    <h4><b>REZERVE SUNUCULAR</b></h4>
                </div>
                <div className="p-col-12 p-sm-12 p-md-6 p-lg-6 p-xl-6" align="right">
                <span className="p-input-icon-left">
                    <i className="pi pi-search"/>
                    <InputText value={globalFilter1} onChange={(e) => setGlobalFilter1(e.target.value)}
                               placeholder="Genel Arama"/>
                </span>
                </div>
            </div>
        </div>
    );

    const getServerBody = (compute_key, compute_name) => {
        const serverBody = (rowData) => {
            return (
                <React.Fragment>
                    <div className="p-grid">
                        <div className="p-col-12" align="center">
                            <span className="p-column-title">{compute_name}</span>
                        </div>
                        <div className="p-col-12" align="center" style={{wordBreak: "break-all"}}>
                            {rowData[compute_key] ? rowData[compute_key] : <span>-</span>}
                        </div>
                    </div>
                </React.Fragment>
            );
        }
        return serverBody;
    }

    const getFlavorBody = (compute_key, compute_name) => {
        const flavorBody = (rowData) => {
            let k = 0;
            for (let i = 0; i < servList.length; i++) {
                if (rowData["server_id"] === servList[i]["server_id"]) {
                    k = i;
                }
            }
            return (
                <React.Fragment>
                    <div className="p-grid">
                        <div className="p-col-12" align="center">
                            <span className="p-column-title">{compute_name}</span>
                        </div>
                        <div className="p-col-12" align="center" style={{wordBreak: "break-all"}}>
                            <Tooltip target={".avatar" + k}>
                                <div className="p-grid" style={{wordBreak: 'break-all'}}>
                                    <div className="p-col-12">
                                        <strong>Kullanılan Kaynaklar</strong>
                                    </div>
                                    <div className="p-col-12 p-sm-12 p-md-6 p-lg-6 p-xl-6">
                                        <strong><i className='pi pi-circle-on'/>&nbsp; CPU</strong>
                                    </div>
                                    <div className="p-col-12 p-sm-12 p-md-6 p-lg-6 p-xl-6">
                                        {rowData['flavor_data']['cpu']} Adet
                                    </div>
                                    <div className="p-col-12 p-sm-12 p-md-6 p-lg-6 p-xl-6">
                                        <strong><i className='pi pi-circle-on'/>&nbsp; GPU</strong>
                                    </div>
                                    <div className="p-col-12 p-sm-12 p-md-6 p-lg-6 p-xl-6">
                                        {rowData['flavor_data']['gpu']} Adet
                                    </div>
                                    <div className="p-col-12 p-sm-12 p-md-6 p-lg-6 p-xl-6">
                                        <strong><i className='pi pi-circle-on'/>&nbsp; RAM</strong>
                                    </div>
                                    <div className="p-col-12 p-sm-12 p-md-6 p-lg-6 p-xl-6">
                                        {rowData['flavor_data']['ram']}
                                    </div>
                                    <div className="p-col-12 p-sm-12 p-md-6 p-lg-6 p-xl-6">
                                        <strong><i className='pi pi-circle-on'/>&nbsp; DISK</strong>
                                    </div>
                                    <div className="p-col-12 p-sm-12 p-md-6 p-lg-6 p-xl-6">
                                        {rowData['flavor_data']['disk']}
                                    </div>
                                </div>
                            </Tooltip>
                            {rowData[compute_key] ?
                                <div>
                                    {rowData[compute_key]} &nbsp;
                                    <i className={"pi pi-info-circle avatar" + k}
                                       data-pr-position="right"
                                       data-pr-at="right+10 top" data-pr-my="left center-2"/>
                                </div>
                                :
                                <span>-</span>}
                        </div>
                    </div>
                </React.Fragment>
            );
        }
        return flavorBody;
    }

    const processBody = (rowData) => {
        return (
            <React.Fragment>
                <div className="p-grid">
                    <div className="p-col-12">
                        <span className="p-column-title">İŞLEVLER</span>
                    </div>
                    <div className="p-col-12">
                        <div className='p-grid'>
                            <div className="p-col-12">
                                <SplitButton label="İşlemler"
                                             icon="pi pi-sliders-h"
                                             model={create_item(rowData)}
                                             className="p-button-text p-button-raised p-button-secondary p-mr-2"
                                >
                                </SplitButton>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }

    const getHeader = (value) => {
        return (
            <div align="center">{value}</div>
        );
    }
    const computeFinishTime = (finish_time) => {
        const dateParts = finish_time.split(', ')[0].split('/'); // ['23', '04', '2023']
        const timeParts = finish_time.split(', ')[1].split(':'); // ['00', '00', '00']
        const year = parseInt(dateParts[2], 10);
        const month = parseInt(dateParts[1], 10) - 1; // ay 0-11 arası bir sayı ile temsil edilir
        const day = parseInt(dateParts[0], 10);
        const hour = parseInt(timeParts[0], 10);
        const minute = parseInt(timeParts[1], 10);
        const second = parseInt(timeParts[2], 10);

        const finish_date = new Date(year, month, day, hour, minute, second);
        const diff_time = new Date(finish_date).getTime() - new Date().getTime();

        const msInDay = 1000 * 60 * 60 * 24; // bir günün milisaniye cinsinden değeri
        const differenceInDays = Math.floor(diff_time / msInDay);
        const remainingMs = diff_time % msInDay;
        const differenceInHours = Math.floor(remainingMs / (1000 * 60 * 60));
        const remainingMs2 = remainingMs % (1000 * 60 * 60);
        const differenceInMinutes = Math.floor(remainingMs2 / (1000 * 60));
        const remainingMs3 = remainingMs2 % (1000 * 60);
        const differenceInSeconds = Math.floor(remainingMs3 / 1000);
        const result = "Kalan Süre: " + differenceInDays + " gün, " + differenceInHours + " saat, " + differenceInMinutes + " dakika";
        let severity = "success";
        if (differenceInDays >= 7) {
            severity = "#0abf53";
        } else if (differenceInDays >= 2) {
            severity = "#f48924";
        } else {
            severity = "#ff0000";
        }
        return [result, severity];
    }

    const reservationFinishTimeBody = (rowData) => {
        const res = rowData["finish_time"] ? computeFinishTime(rowData["finish_time"]) :
            <span>-</span>
        return (
            <React.Fragment>
                <div className="p-grid">
                    <div className="p-col-12" align="center">
                        <span className="p-column-title">Bitiş Tarihi</span>
                    </div>
                    <div className="p-col-12" align="center" style={{wordBreak: "break-all", color: res[1]}}>
                        {rowData["finish_time"] ? rowData["finish_time"] : <span>-</span>}
                    </div>
                    <div className="p-col-12" align="center">
                        <Tooltip target=".finish-time-icon"/>
                        <i className="finish-time-icon pi pi-info-circle" data-pr-position="right"
                           data-pr-at="right+10 top" data-pr-my="left center-2"
                           data-pr-tooltip={res[0]} style={{color: res[1]}}>
                        </i>
                    </div>
                </div>
            </React.Fragment>
        );
    }

    const serverDialogonHide = () => {
        setServerDialog(false)
    }

    const serverUpdateDialogOnHide = () => {
        setServerName(null);
        setServerDetail(null);
        setServerUpdateDialog(false);
    }

    const reservationDialogOnHide = () => {
        setSelectedReservation(null)
        setReservationDialog(false);
    }

    const textController = (func, value) => {
        var re = /^[a-zA-Z0-9 _ıİçÇşŞöÖüÜğĞ.]*$/;
        if (re.test(value) || value.length === 0) {
            func(value);
        } else {
            showError("Yalnızca Harf, Sayı ve Alt Çizgi Kullanılmalıdır");
        }
    }

    const renderUpdateFooter = () => {
        return (
            <div>
                <Button
                    label="İptal"
                    className="p-button-text p-button-raised p-button-danger"
                    onClick={(e) => serverUpdateDialogOnHide()}
                />
                <Button
                    label="Güncelle"
                    className="p-button-text p-button-raised p-button-success"
                    onClick={(e) => updateServer()}
                />
            </div>
        );
    }

    const renderReservationFooter = () => {
        return (
            <div>
                <Button
                    label="İptal"
                    className="p-button-text p-button-raised p-button-danger"
                    onClick={(e) => reservationDialogOnHide()}
                />
                <Button
                    label="Başlat"
                    className="p-button-text p-button-raised p-button-success"
                    onClick={(e) => serverStartWithReservation()}
                />
            </div>
        );
    }

    const headerGroup = (
        <ColumnGroup>
            <Row>
                <Column header=""/>
                <Column header={"REZERVASYON"} colSpan={2}/>
                <Column header={"SUNUCU BİLGİLERİ"} colSpan={7}/>
            </Row>
            <Row>
                <Column header="Sunucu Adı"
                        style={{fontWeight: 'bold', textAlign: 'center', width: '5.5em'}}/>
                <Column header="Başlangıç Tarihi"
                        style={{fontWeight: 'bold', textAlign: 'center', width: '5.5em'}}/>
                <Column header="Bitiş Tarihi"
                        style={{fontWeight: 'bold', textAlign: 'center', width: '5.5em'}}/>
                <Column header="Şablon"
                        style={{textAlign: 'center', width: '5.5em'}}/>
                <Column header="İmaj"
                        style={{fontWeight: 'bold', textAlign: 'center', width: '5.5em'}}/>
                <Column header="Anahtar Çifti"
                        style={{textAlign: 'center', width: '5.5em'}}/>
                <Column header="IP Adresi"
                        style={{fontWeight: 'bold', textAlign: 'center', width: '5.5em'}}/>
                <Column header="Durum"
                        style={{textAlign: 'center', width: '5.5em'}}/>
                <Column header="Güç"
                        style={{fontWeight: 'bold', textAlign: 'center', width: '5.5em'}}/>
                <Column header="İşlevler"
                        style={{textAlign: 'center', width: '5.5em'}}/>
            </Row>
        </ColumnGroup>
    );

    const products = [
        {
            "src": add_new_server_png,
            "name": "Yeni Sunucu Ekle",
            "text": <p style={{fontSize: '15px'}}>
                Şuan mevcut bulunan kredimiz 1 numara ile gösterilen alanda gösterilmektedir.
                Talep edilen rezervasyon onaylandıktan sonra Ekranda 2 numara ile gösterilen
                <b>"Yeni Sunucu Ekle"</b> butonuna tıklanır.
            </p>
        },
        {
            "src": server_informations_png,
            "name": "Sunucu Bilgileri",
            "text": <p style={{fontSize: '15px'}}>
                Sunucu Ekle Butonuna tıkladıktan sonra ilk adımda sunucuya ait bilgilerin girildiği ekran
                karşımıza çıkar. Bu ekranda yer alan <b>"Sunucu Adı"</b> alanına sunucuya vermek istediğimiz
                ad girilir. Bu alanın boş bırakılmaması gerekmektedir. Boş bırakıldığı takdirde son sunucu oluşturma
                adımında hata alınacaktır.
                Daha sonra altında yer alan <b>"Açıklama"</b> alanına sunucuya ait bilgilendirme içeren bilgiler
                girilir. Gerekli bilgiler girildikten sonra görselin sağ alt tarafında görüldüğü gibi
                <b> "Sonraki Adım"</b> butonuna tıklanarak ikinci adıma geçilir.
            </p>
        },
        {
            "src": select_reservation_png,
            "name": "Rezervasyon Seçimi",
            "text": <p style={{fontSize: '15px'}}>
                İlk adım tamamlandıktan sonra ikinci adım olan rezervasyon seçimine geçilir. Görselde görüldüğü gibi
                onaylanmış ve rezervasyon süresi içerisinde yer aldığımız rezervasyonlar görülmektedir. Öncelikle
                tabloda yer alan bir rezervasyon seçilir. Daha sonra görselin sağ altında yer alan
                <b> "Sonraki Adım"</b> butonuna tıklanarak üçüncü adıma geçilir.
            </p>
        },
        {
            "src": select_image_png,
            "name": "İmaj Seçimi",
            "text": <p style={{fontSize: '15px'}}>
                Üçüncü adımda oluşturulacak olan sunucuda kullanılmak istenen işletim sisteminin bulunduğu imaj seçilir.
                Görselde görüldüğü gibi yüklü imajların bulunduğu tablo bulunmaktadır. İstenen imaj tablodan seçilerek
                <b> "Sonraki Adım"</b> butonuna tıklanarak dördüncü adıma geçilir.
            </p>
        },
        {
            "src": enter_keypair_png,
            "name": "Anahtar Çifti Bilgisi",
            "text": <p style={{fontSize: '15px'}}>
                Dördüncü adımda Anahtar Çifti için bir isim belirlenir. Anahtar Çifti sunucu oluşturulduktan sonra
                sunucuya erişmek için kullanılan bir anahtar dosyasıdır. sunucu oluşturulduktan sonra anahtar dosyası
                .pem uzantılı olarak indilebilmektedir. Görselde görülen <b>"Anahtar Çifti Adı"</b> alanına
                bir isim girilir. Bu alanda kullanılacak isim sadece harf, sayı ve alt-çizgi (_) içerebilir.
                Gerekli bilgiler doldurulduktan sonra <b>"Sonraki Adım"</b> butonuna tıklanarak son adıma geçilir.
            </p>
        },
        {
            "src": server_summary_png,
            "name": "Sunucu Özeti",
            "text": <p style={{fontSize: '15px'}}>
                Son adımda oluşturulacak sunucuya ait özet bilgiler yer almaktadır. Bu bilgiler kontrol edilir.
                İstenilmeyen bir durum görüntülendiği takdirde önceki adımlara geri dönülerek değişiklik
                yapılabilmektedir. Bilgilerin doğruluğu kontrol edildikten sonra Görselin sağ altında yer alan
                <b> "Sunucuyu Oluştur"</b> butonuna tıklanır. Daha sonra sunucu oluşturulmaya başlar.
                Sunucunun oluşturulması ve aktif hale gelmesi biraz zaman alabilmektedir.
            </p>
        },
    ];

    const productTemplate = (product) => {
        return (
            <div className="product-item">
                <div className="product-item-content">
                    <div className="p-mb-3">
                        <img src={product.src} alt={product.name} width='100%' style={{objectFit: 'contain'}}/>
                    </div>
                    <div>
                        <h4 className="p-mb-1">{product.name}</h4>
                        <h6 className="p-mt-0 p-mb-3">{product.text}</h6>
                    </div>
                </div>
            </div>
        );
    }

    if (serverListRole) {
        return (
            <div>
                <Spinner loadingState={loadingState}/>
                <div className="p-grid">
                    <div className="p-col-10 p-sm-10 p-md-6 p-lg-6 p-xl-2">
                        <Button icon="pi pi-file-pdf" className="p-button-danger p-button-rounded p-mb-5"
                                label="Rezervasyon Rehber Kılavuzu"
                                tooltip="Rezervasyon Rehber Kılavuzu İndir"
                                onClick={(e) => downloadReservationGuide()}/>
                    </div>
                    <div className="p-col-10 p-sm-10 p-md-6 p-lg-6 p-xl-2">
                        <Button icon="pi pi-info" className="p-button-secondary p-button-rounded"
                                label="Sunucu Oluşturma Adımları"
                                onClick={() => setInfoDialog(true)}/>
                    </div>

                </div>
                <div className="p-grid p-mt-3 card">
                    <div className="p-col-12 p-sm-12 p-md-6 p-lg-6 p-xl-6">
                        {serverAddRole
                            ?
                            <Button label="Yeni Sunucu  Ekle" icon="pi pi-plus"
                                    className="p-button-secondary p-button-text p-button-raised"
                                    style={{width: '210px', height: '35px'}}
                                    onClick={() => setServerDialog(true)}/>
                            :
                            <Message severity="warn"
                                     text="Krediniz Bulunmamaktadir. Lütfen Kredi Talebinde Bulununuz."/>
                        }
                    </div>
                    <div className="p-col-12 p-sm-12 p-md-6 p-lg-6 p-xl-6" align="right">
                        <Button label="Mevcut Krediniz" icon="pi pi-money-bill"
                                className="p-button-rounded p-button-info"
                                disabled>
                            <Tag className="p-ml-2" severity="warning" style={{fontSize: '12px'}} value={credit}/>
                        </Button>
                    </div>

                </div>

                <Toast ref={toast}/>
                <Dialog header="UYARI" visible={serverDeleteDialog}
                        style={{width: '20%'}}
                        onHide={() => setServerDeleteDialog(false)}
                        dismissableMask
                >
                    <div className="confirmation-content">
                        <i className="pi pi-exclamation-triangle p-mr-3" style={{fontSize: '2rem'}}/>
                        <span>Silmek İstediğinizden Emin Misiniz?</span>
                    </div>


                </Dialog>

                <div className="datatable-responsive-demo">

                    <div className="card">
                        <DataTable
                            responsive={true}
                            value={servList}
                            paginator
                            resizableColumns={true}
                            className="p-datatable-responsive-demo"
                            rows={10} dataKey="id"
                            rowHover globalFilter={globalFilter1} emptyMessage="Kayıt Bulunamadı."
                            header={customer1TableHeader}
                            headerColumnGroup={headerGroup}
                        >
                            <Column field={'server_name'}
                                    body={getServerBody("server_name", "Sunucu Adı")}
                            />
                            <Column field={'start_time'}
                                    body={getServerBody("start_time", "Başlangıç Tarihi")}
                                    style={{textAlign: 'left', width: '5.5em'}}
                            />
                            <Column field={'finish_time'}
                                    body={reservationFinishTimeBody}
                                    style={{fontWeight: 'bold', textAlign: 'left', width: '5.5em'}}
                            />
                            <Column field={'server_flavor'}
                                    body={getFlavorBody("server_flavor", "Şablon")}
                                    style={{textAlign: 'left', width: '5.5em'}}
                            />
                            <Column field={'server_image'}
                                    body={getServerBody("server_image", "İmaj")}
                                    style={{textAlign: 'left', width: '5.5em'}}
                            />
                            <Column field={'keypair'}
                                    body={getServerBody("keypair", "Anahtar Çifti")}
                                    style={{fontWeight: 'bold', textAlign: 'left', width: '5.5em'}}
                            />
                            <Column field={'server_ip'}
                                    body={getServerBody("server_ip", "IP Adresi")}
                                    style={{textAlign: 'left', width: '5.5em'}}
                            />
                            <Column field={'status'}
                                    body={getServerBody("status", "Durum")}
                                    style={{fontWeight: 'bold', textAlign: 'left', width: '5.5em'}}
                            />
                            <Column field={'power_state'}
                                    body={getServerBody("power_state", "Güç")}
                                    style={{textAlign: 'left', width: '5.5em'}}
                            />
                            <Column body={processBody}/>


                        </DataTable>
                    </div>
                </div>

                <Dialog header="Sunucu Ekle"
                        visible={serverDialog}
                        style={{width: '75%'}}
                        onHide={serverDialogonHide} maximizable
                        dismissableMask
                >
                    <AddServer setServerDialog={setServerDialog}
                               getServList={getServList}
                               showSuccessMessage={showSuccess}
                               showErrorMessage={showError}
                               showInfoMessage={showInfo}/>

                </Dialog>

                <Dialog
                    header="Sunucuyu Güncelle"
                    visible={serverUpdateDialog}
                    style={{width: '75%'}}
                    footer={renderUpdateFooter}
                    onHide={serverUpdateDialogOnHide}
                    dismissableMask
                >
                    <div className="p-grid" style={{marginTop: "10px"}}>
                        <div className="p-col-12">
                            <span className="p-float-label">
                                <InputText id="server_name" value={serverName} style={{width: "100%"}}
                                           onChange={(e) => textController(setServerName, e.target.value)}/>
                                <label htmlFor="server_name">Sunucu Adı</label>
                            </span>
                        </div>
                        <div className="p-col-12" style={{marginTop: '10px'}}>
                            <span className="p-float-label">
                                <InputTextarea id="server_detail" rows={5} cols={30}
                                               value={serverDetail} style={{width: "100%"}}
                                               onChange={(e) => textController(setServerDetail, e.target.value)}
                                               autoResize/>
                                <label htmlFor="server_detail">Açıklama</label>
                            </span>
                        </div>
                    </div>
                </Dialog>


                <Dialog
                    header="Rezervasyon Seç"
                    visible={reservationDialog}
                    style={{width: '75%'}}
                    footer={renderReservationFooter}
                    onHide={reservationDialogOnHide}
                    dismissableMask
                >
                    <div className="p-grid" style={{marginTop: "10px"}}>
                        <div className="p-col-12">
                            <span className="datatable-responsive-demo">
                                <DataTable header={getHeader("UYGUN REZERVASYONLAR")}
                                           paginator
                                           rows={10}
                                           value={reservations}
                                           selectionMode="single"
                                           selection={selectedReservation}
                                           onSelectionChange={(e) => setSelectedReservation(e.value)}
                                           dataKey="id"
                                           className="p-datatable-responsive-demo"
                                           emptyMessage="Kayıt Bulunamadı"
                                >
                                    <Column field="flavor_name"
                                            header="Şablon Adı"
                                            body={getServerBody("flavor_name", "Şablon Adı")}
                                            style={{fontWeight: 'bold', textAlign: 'left', width: '5.5em'}}
                                    />
                                    <Column field="reservation_starttime"
                                            header="Başlama Tarihi"
                                            body={getServerBody("reservation_starttime", "Başlama Tarihi")}
                                            style={{textAlign: 'left', width: '5.5em'}}
                                    />
                                    <Column field="reservation_finishtime"
                                            header="Bitiş Tarihi"
                                            body={getServerBody("reservation_finishtime", "Bitiş Tarihi")}
                                            style={{fontWeight: 'bold', textAlign: 'left', width: '5.5em'}}
                                    />
                                </DataTable>
                            </span>
                        </div>
                    </div>
                </Dialog>

                <Dialog header="Bilgi" visible={infoDialog}
                        style={{width: '75%'}}
                        breakpoints={{'960px': '100%'}}
                        onHide={() => setInfoDialog(false)}
                        dismissableMask
                >
                    <div className="p-fluid p-grid">
                        <div className="p-col-12 carousel-demo" align="center" style={{width: '100%'}}>
                            <Carousel value={products} numVisible={1} numScroll={1} page={0}
                                      style={{width: '100%'}} itemTemplate={productTemplate}
                            />
                        </div>
                    </div>


                </Dialog>

            </div>
        )
    } else {
        return (
            window.location.hash = "/loanrequest"
            // <Redirect to="#notfound"/>
        )
    }

}

const mapStateToProps = state => {
    return {
        user: state.auth.user,
        management: state.management,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        putMethod: (data, url, type) => {
            return dispatch(management.putMethod(data, url, type));
        },
        postMethod: (data, url, type) => {
            return dispatch(management.postMethod(data, url, type));
        },
        deleteMethod: (data, url, type) => {
            return dispatch(management.deleteMethod(data, url, type));
        },
        logout: () => dispatch(auth.logout()),
        loadUser: () => {
            return dispatch(auth.loadUser());
        },

    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Server);



// WEBPACK FOOTER //
// ./src/pages/cloudmanagement/Server.jsx